const items = [
  "LICENSED & INSURED",
  "SE HABLA ESPAÑOL",
  "LOCALLY OWNED · PITTSBURGH",
  "QUARTERLY & ONE-TIME SERVICE",
  "WOOD-DESTROYING INSECT SPECIALISTS",
  "WILDLIFE REMOVAL",
  "BED BUG ERADICATION",
  "MOSQUITO CONTROL",
];

const Marquee = () => {
  const doubled = [...items, ...items];
  return (
    <div className="bg-[#0B2B40] border-y-2 border-zinc-900 overflow-hidden py-5">
      <div className="marquee-track flex items-center gap-12 whitespace-nowrap">
        {doubled.map((label, i) => (
          <div key={i} className="flex items-center gap-12">
            <span className="font-display uppercase text-white text-2xl md:text-3xl tracking-tight">
              {label}
            </span>
            <span className="text-[#D9480F] text-3xl leading-none">✦</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
